import styled from 'styled-components';

const ModalWrapper = styled.div`
  position: absolute;
  top: -30px;
  left: ${(p) => (p.position ? 45 : -395)}px;
  z-index: ${(p) => (p.zIndex ? p.zIndex : 1003)};
`;

const Backdrop = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
`;

const Container = styled.div`
  padding: 15px;
  background-color: ${(p) => p.theme.color.backgroundRush};
  margin-${(p) => (p.position ? 'left' : 'right')}: 30px;
  box-sizing: border-box;
  box-shadow: 0px 15px 40px #0000001F;
  border-radius: 20px;
`;

const List = styled.div`
  display: grid;
  gap: 5px;
  grid-template-columns: repeat(8, 40px);
`;

const IconContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme.color.background};
  background-color: ${(p) =>
    !p.isSelected ? p.theme.color.backgroundRush : p.theme.color.turquoise};
  box-sizing: border-box;
  cursor: pointer;
  transition: all ${(p) => p.theme.duration.s} linear;
  svg {
    fill: ${(p) => (p.isSelected ? p.theme.color.white : p.theme.color.gray)};
    path {
      fill: ${(p) => (p.isSelected ? p.theme.color.white : p.theme.color.gray)};
    }
    circle {
      fill: ${(p) => (p.isSelected ? p.theme.color.white : p.theme.color.gray)};
    }
  }

  &:hover {
    background-color: ${(p) => !p.isSelected && p.theme.color.background};
    border: 1px solid ${(p) => p.theme.color.background};

    svg {
      fill: ${(p) =>
        p.isSelected ? p.theme.color.white : p.theme.color.turquoise};
      path {
        fill: ${(p) =>
          p.isSelected ? p.theme.color.white : p.theme.color.turquoise};
      }
      circle {
        fill: ${(p) =>
          p.isSelected ? p.theme.color.white : p.theme.color.turquoise};
      }
    }
  }
  &:active {
    transform: scaleX(0.95) scaleY(0.95) scaleZ(0.95);
    svg {
      transform: scale(0.8);
    }
  }
`;

export const Styled = {
  ModalWrapper,
  Backdrop,
  Container,
  List,
  IconContainer,
};
